export default __webpack_public_path__ + "static/media/bandcamp.f74934ca.svg";